import React from 'react';
import PublicPage from '../cms/PublicPage';

export default function CommunityPage() {
  return <PublicPage slug="community" />;
}
